export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11006.cd1570c8.jpg";